import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import TechnologyPage from "./pages/TechnologyPage";
import PartnersPage from "./pages/PartnersPage";
import MyStoryWorldPage from "./pages/MyStoryWorldPage";
import CarePage from "./pages/CarePage";
import AdFoundryPage from "./pages/AdFoundryPage";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Home = () => {
  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log(response.data.message);
    } catch (e) {
      console.error(e, `errored out requesting / api`);
    }
  };

  useEffect(() => {
    helloWorldApi();
  }, []);

  // Home redirects to Technology/Platform page
  return <TechnologyPage />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/technology" element={<TechnologyPage />} />
          <Route path="/platform" element={<TechnologyPage />} />
          <Route path="/partners" element={<PartnersPage />} />
          <Route path="/contact" element={<PartnersPage />} />
          <Route path="/mystoryworld" element={<MyStoryWorldPage />} />
          <Route path="/care" element={<CarePage />} />
          <Route path="/ts-ad-foundry" element={<AdFoundryPage />} />
          <Route path="/adfoundry" element={<AdFoundryPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
